/**
 * Created with IntelliJ IDEA.
 * User: vanessat
 * Date: 11/23/14
 * Time: 11:25 AM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {

    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var FilterButtonSelectViewController = require('web-agent-components/FilterButtonSelectViewController');
    var FilterDropdownViewController = require('web-agent-components/FilterDropdownViewController');
    var FilterDropdownSelectionViewController = require('web-agent-components/FilterDropdownSelectionViewController');

    var AgentListTableViewController = BaseTableViewController.extend({
        ControllerName: "AgentListTableViewController",
        applicationType: "AgentListTableViewController",

        focusedName: "AgentListTable",

        LPViewMap: {
        },

        LPPrefixMap: {
            agentList: "AGENT_LIST"
        },

        LPClassesMap: {
            messaging: 'messaging'
        },

    initialize : function () {
    this.agentStatusReasons = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentReasonsCollection);},

        events: function () {
        },

        render: function () {
        }

    });

    AgentListTableViewController.prototype.getConfiguration = function () {
        var modelController = lpTag.WebAgent.agentListController;
        var configuration = {
            updateQueryCallback: modelController.updateQuery,
            context: this,
            textsPrefix: this.LPPrefixMap.agentList,
            tableName: this.applicationType,
            tableRootModelPath: "agentList",
            globalData: {
                modelController: modelController,
                tableName: this.applicationType,
                textsPrefix: this.LPPrefixMap.agentList
            },
            tableHead: {
                defaultSortTag: modelController.getDefaultValue("sortTag"),
                defaultSortOrder: modelController.getDefaultValue("sortOrder"),
                columnsData: this.getColumnsData(modelController)
            },
            tableBody: {
                htmlTable: true,
                ignoreRowHover: true,
                ignoreSectionHover: true,
                rowTemplateFile: this.getRowTemplateFile(),
                dataRenderer: this.dataRenderer,
                supportKeysNavigation: false,
                dataBinder: {},
                disableLineClick: true
            },
            paging: {
                pageSize: 50
            }
        };
        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            configuration.tableHead.headerRowClassName += " hide_agentGroups";
        }
        return configuration;
    };

    AgentListTableViewController.prototype.getRowTemplateFile = function () {
        var rowTemplateFile;
        rowTemplateFile = 'LP_agent_list_table_row.html';
        return rowTemplateFile;
    };

    AgentListTableViewController.prototype.getColumnsData = function (modelController) {

        var columnsData = [
            {
                iconType: "agents_header_status",
                tooltip: "AGENT_LIST_table_column_status_tooltip",
                tooltipAlign: "left",
                filter: {
                    filterManager: FilterButtonSelectViewController,
                    filterManagerData: {
                        filterName: "agentStatus",
                        filterTextSuffix: "agentStatus",
                        defaultFilter: {status: modelController.getDefaultValue("agentStatus.status")},
                        defaultFilterIsActive: true,
                        buttons: [
                            {
                                status: "4",
                                buttonId: "away",
                                iconClass: "agent_status",
                                iconType: "Away",
                                buttonText: "{{filter_away_agentStatus}}"
                            }, {
                                status: "3",
                                buttonId: "back_soon",
                                iconClass: "agent_status",
                                iconType: "Back_Soon",
                                buttonText: "{{filter_back_soon_agentStatus}}"
                            }, {
                                status: "2",
                                buttonId: "online",
                                iconClass: "agent_status",
                                iconType: "Online",
                                buttonText: "{{filter_online_agentStatus}}"
                            }
                        ]
                    }
                }
            }, {
                title: "AGENT_LIST_table_column_elapsedTimeInState",
                tooltip: "AGENT_LIST_table_column_elapsedTimeInState_tooltip"
            }, {
                title: "AGENT_LIST_table_column_agentName",
                tooltip: "AGENT_LIST_table_column_agentName_tooltip",
                sortTag: "name"
            }, {
                title: "activeChatAgentGroup",
                tooltip: "activeChatAgentGroupTooltip",
                sortTag: "agentGroupName",
                filter: {
                    filterManager: FilterDropdownSelectionViewController,
                    filterManagerData: {
                        className: "filter_dropdown_selection_view",
                        filterName: "agentGroupIds",
                        filterTextSuffix: "agentGroups",
                        filterDataModelPath: "agent.agentGroups.array",
                        textProperty: "displayName"
                    }
                }
            },
            {
                title: "AGENT_LIST_table_column_skills",
                tooltip: "AGENT_LIST_table_column_skills_tooltip",
                filter: {
                    filterManager: FilterDropdownViewController,
                    filterManagerData: {
                        className: "filter_skills_dropdown_view filter_dropdown_selection_view",
                        filterName: "skillNames",
                        filterTextSuffix: "skills",
                        filterDataModelPath: "skills.array",
                        textProperty: "name",
                        titleText: "AGENT_LIST_filter_skills_title",
                        buttonTitleEnabled: true
                    }
                }
            },
            {
                title: "AGENT_LIST_table_column_concurrent",
                tooltip: "AGENT_LIST_table_column_concurrent_tooltip"
            }, {
                title: "AGENT_LIST_table_column_maxConcurrent",
                tooltip: "AGENT_LIST_table_column_maxConcurrent_tooltip"
            }
        ];

        return columnsData;
    };

    AgentListTableViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var agentInfo = data[rowIndex];
            var value = {};
            if (agentInfo) {
                value.id = agentInfo.id;
                value.darkLine = rowIndex % 2 === 0 ? 'dark_line' : '';
                value.agentStatus = agentInfo.status || "Offline";
                value.agentStatusTooltip = getAgentStatusTooltip(this);
                var duration = lpTag.WebAgent.logicController.getFormatDurationTime(Number(agentInfo.elapsedTimeInState));
                value.elapsedTimeInState = duration.text;
                value.elapsedTimeInStateTooltip = duration.tooltip;
                value.agentName = agentInfo.name || '';
                value.firstSkillName = agentInfo.skills.length === 0 ? this.translate('unassigned') : agentInfo.skills[0].name;
                value.concurrent = agentInfo.concurrent;
                value.maxConcurrent = agentInfo.maxConcurrent === '-1' ? this.translate('AGENT_LIST_unlimited') : agentInfo.maxConcurrent;
                value.nickname = this.translate('AGENT_LIST_nickname') + ": " + agentInfo.nickname;

                if (lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                    if (agentInfo.agentGroupId && agentInfo.agentGroupName !== "") {
                        value.agentGroup = agentInfo.agentGroupName;
                        value.agentGroupTooltip = agentInfo.agentGroupName;
                    } else {
                        value.agentGroup = this.translate('notAvailable');
                        value.agentGroupTooltip = this.translate('notAvailable');
                    }
                } else {
                    value.className += " hide_agentGroups";
                }
                // handle skills tooltip
                value.other_skills_hidden = agentInfo.skills.length > 1 ? '' : 'hidden';
                value.otherSkillsNum = agentInfo.skills.length > 1 ? agentInfo.skills.length - 1 : '';
                value.skills = agentInfo.skills.length > 1 ? getSkillsTooltip(agentInfo.skills) : '';
            }

            function getSkillsTooltip(skills) {
                var skillsTooltip = '';
                for (var i = 1; i < skills.length; i++) {
                    skillsTooltip += skills[i].name + '<br/>';
                }
                return skillsTooltip;
            }

        function getAgentStatusTooltip(context) {
            var statusTooltip;
            if(agentInfo.chatReasonId) {
                statusTooltip = context.agentStatusReasons.getTextById(agentInfo.chatReasonId);
            } else {
                statusTooltip = (agentInfo.status === 'Back_Soon') ? context.translate('backIn5') : context.translate(agentInfo.status.toLowerCase());
            }
            return statusTooltip;
        }return value;
    }
};

    return AgentListTableViewController;

});
